export default __webpack_public_path__ + "static/media/MVIMG_20190506_081223.723dc49a.jpg";